import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const EMAIL_WITH_TLD = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;

export function emailWithTldValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    return EMAIL_WITH_TLD.test(control.value) ? null : { email: true };
  };
}
